/**
 * Step-progress model (pure) — the four working steps the referee walks between, and how a flow
 * step maps onto that 4-node track. Kept out of the component file so both StepProgress (dots) and
 * AppShell (the screen-reader label) can share it without a component/non-component export mix.
 */
import type { FlowStep } from './steps';

export const PROGRESS_NODES: { key: 'confirm' | 'record' | 'review' | 'sign'; label: string }[] = [
  { key: 'confirm', label: 'Details' },
  { key: 'record', label: 'Record' },
  { key: 'review', label: 'Review' },
  { key: 'sign', label: 'Sign' },
];

/** Position of a flow step on the track. `processing` sits on Review (in progress). -1 = off-track. */
export function progressActiveIndex(step: FlowStep): number {
  switch (step) {
    case 'confirm':
      return 0;
    case 'record':
      return 1;
    case 'processing':
    case 'review':
      return 2;
    case 'sign':
      return 3;
    default:
      return -1; // landing / done → not on the track
  }
}

/** Accessible label describing progress for screen readers (the visible dots are aria-hidden). */
export function stepProgressLabel(step: FlowStep): string | undefined {
  const active = progressActiveIndex(step);
  if (active < 0) return undefined;
  return `Step ${active + 1} of ${PROGRESS_NODES.length}: ${PROGRESS_NODES[active].label}`;
}
